import PropTypes from "prop-types"

/**
 * PropTypes for PriceListFormModal component.
 *
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Function} onClose - Callback to close modal
 * @property {Function} onSave - Callback to save the price list
 * @property {Object|null} [priceList] - Existing price list to edit (null for create mode)
 * @property {string} [formError] - Server-side error to surface inline (e.g. overlap conflict)
 */
export const priceListFormModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	priceList: PropTypes.object,
	formError: PropTypes.string,
}

/**
 * PropTypes for PriceListDeleteModal component.
 *
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Function} onClose - Callback to close modal
 * @property {Function} onConfirm - Callback to confirm deletion
 * @property {Object|null} [priceList] - Price list to delete
 */
export const priceListDeleteModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	priceList: PropTypes.object,
}

/**
 * PropTypes for CemePriceList view.
 * No external props are expected; kept for consistency across view definitions.
 */
export const cemePriceListViewPropTypes = {}

/**
 * PropTypes for the CemePriceList SidebarSection component.
 *
 * @property {Object|null} selectedPriceList - Currently selected price list (null if no selection)
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Total number of price lists matching the current filters
 * @property {boolean} userIsAdmin - Whether the current user may edit/delete/toggle price lists
 * @property {Function} onEdit - Opens the edit modal for the selected price list
 * @property {Function} onToggleActive - Activates/deactivates the selected price list
 * @property {Function} onDelete - Opens the delete confirmation for the selected price list
 */
export const cemePriceListSidebarSectionPropTypes = {
	selectedPriceList: PropTypes.object,
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	visibleCount: PropTypes.number.isRequired,
	userIsAdmin: PropTypes.bool.isRequired,
	onEdit: PropTypes.func.isRequired,
	onToggleActive: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
}
